<template>
  <div class="info-wrapper">
    <div class="info-header" @click="showContent = !showContent">
      <slot name="title"></slot>
      <button class="more" :class="{'active': showContent}">
        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6 5.60876L10.4834 0.75L12 2.24761L6 8.75L-6.54624e-08 2.24761L1.51664 0.75L6 5.60876Z" fill="black" fill-opacity="0.65"/>
        </svg>
      </button>
    </div>
    <div class="info-content" v-if="showContent">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleComponentVue',
  data () {
    return {
      showContent: false
    }
  }
}
</script>

<style lang="scss">
.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  h5 {
    margin-bottom: 0;
  }
  button {
    transition: .3s;
    &.active {
      transform: rotate(180deg);
    }
  }
}
.info-content {
  margin-top: 15px;
  .owner-block-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ToggleComponentVue.vue